import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';

const CustomDropdown = ({
  visitOptionData,
  selectedAppointment,
  handleChange,
  handleStartVisit,
  currentVisitFetchStatus,
  startStatus
}: any) => {
  const [value, setValue] = React.useState<any>(null);
  const { checkPermission } = usePermissionWrapper();
  const [buttonVariant, setButtonVariant] = React.useState<'contained' | 'outlined'>('contained');

  const groupBy = (option: any) =>
    visitOptionData.upcomingAppointments.find((item: any) => item.label === option.label)
      ? 'Upcoming Appointments'
      : 'Past Appointments';

  const getOptionLabel = (option: any) => {
    return `${option.label} ${option.datetime}`;
  };
  const handleButtonClick = () => {
    setButtonVariant(prevVariant => (prevVariant === 'contained' ? 'outlined' : 'contained'));
    handleStartVisit(selectedAppointment);
  };
  const fetchStatus = {
    initiated: 'CRF Data Pull Status: Initiated',
    inprogress: 'CCRF Data Pull Status: In-Prgress',
    completed: 'CRF Data Pull Status: Completed'
  };
  const [open, setOpen] = React.useState(false);
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
      <Autocomplete
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={value}
        onChange={(event, newValue) => {
          setOpen(false);
          setButtonVariant('contained');
          handleChange(newValue);
          setValue(newValue);
        }}
        options={[...visitOptionData.upcomingAppointments, ...visitOptionData.pastAppointments]}
        groupBy={groupBy}
        getOptionLabel={getOptionLabel}
        style={{ flex: 1 }}
        classes={{
          groupUl: 'custom-group-ul'
        }}
        renderInput={params => (
          <TextField
            {...params}
            label={value ? 'Appointment' : 'Pick an appointment'}
            placeholder={value ? '' : 'Appointment'}
            InputProps={{
              ...params.InputProps
            }}
            style={{ marginLeft: '-15px', paddingLeft: '5px' }}
          />
        )}
        renderOption={(props, option: any) => {
          return (
            <li {...props} style={{ padding: '-8px -16px' }}>
              <p style={{ marginTop: '-5px', marginBottom: '0px' }}>
                <strong>{option.label}</strong>
                <br />
                {option.datetime}
              </p>
            </li>
          );
        }}
      />
      {selectedAppointment &&
      startStatus == null &&
      selectedAppointment.study_visit.is_visit_started !== 'in_progress' ? (
        <Button
          onClick={handleButtonClick}
          variant={buttonVariant}
          disabled={!checkPermission('start_subject_study_visit')}
          color="primary"
          style={{ marginLeft: '1rem' }}
        >
          {selectedAppointment.study_visit.is_visit_started == 'in_progress' ? (
            <CircularProgress size={20} sx={{ mr: 2, color: '#b8b8b8' }} />
          ) : null}
          {selectedAppointment.study_visit.is_visit_started == 'in_progress'
            ? currentVisitFetchStatus <= 10
              ? fetchStatus.initiated
              : currentVisitFetchStatus > 10
              ? fetchStatus.inprogress
              : currentVisitFetchStatus == 100
              ? fetchStatus.completed
              : ''
            : 'Start Study Visit'}
        </Button>
      ) : null}
    </div>
  );
};
export default CustomDropdown;
